import { Create, ListButton, TopToolbar } from 'react-admin';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import PositionForm from './PositionForm';

const PositionActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const PositionCreate = (props: any) => {
  return (
    <Create actions={<PositionActions {...props} />} {...props}>
      <PositionForm />
    </Create>
  );
};

export default PositionCreate;
